import { default as Mui5ToggleButton, ToggleButtonProps as Mui5ToggleButtonProps } from '@mui/material/ToggleButton'
import { forwardRef } from 'react'

export type ToggleButtonProps = Omit<Mui5ToggleButtonProps, 'classes'>

export const ToggleButton = forwardRef<HTMLButtonElement, ToggleButtonProps>(({ color, ...props }, ref) => {
  const resolvedColor = (color ?? 'secondary') as Mui5ToggleButtonProps['color']
  return <Mui5ToggleButton ref={ref} color={resolvedColor} {...props} />
})
